export default "__VITE_ASSET__DMTd23a8__"